import React, { useState } from "react";
// import "../App.css";
import ParallaxSection from '../components/ParallaxSection'
import LogoCarousel from "../components/LogoCarousel";
import SubBanner from "../components/SubBanner"
import HeartSection from "../components/Health/HeartSection";
import HeartBanner from "../components/Health/HeartBanner";
import SubStory from "../components/Health/SubStory"
import bgImage from "../Assets/tech/techstone.png";
import SubStone from "../components/Health/SubStone";
import SubFounder from "../components/Health/SubFounder";
import MedicalCareCarousel from "../components/Health/MedicalCareCarousel"
import founderPhoto from "../Assets/health/healthfounder.png";
import waveBg from "../Assets/background-wave.png";
import dotPattern from "../Assets/health/Ellipse 164.png";
import vcnrLogo from "../Assets/vcnr-logo-white.png";
import OutreachSection from "../components/Health/HealthcareCommunityOutreach";
import Img1 from "../Assets/tech/tech1.webp";
import Img2 from "../Assets/tech/tech2.webp";
import Img3 from "../Assets/tech/tech3.webp";
import Img4 from "../Assets/tech/tech4.webp";
import Img5 from "../Assets/tech/tech5.webp";
import Img6 from "../Assets/tech/tech6.webp";
import LeaderDivisionSection from "../components/Leadership/LeaderDivisionSection";
import VCNRContactHospitalBanner from "../components/Contact/VCNRContactHospitalBanner";
import LeaderBuildWithUs from "../components/Leadership/LeaderBuildWithUs";
import QuickAccessRow from "../components/Career/QuickAccessRow";
import testimonialbg from "../Assets//rock-bg.png"
import SubJoinSection from "../components/Health/SubJoinSection";
import doctorImage from "../Assets/ethosperson.png";
import Subservicesmediacarousel from "../components/Health/Subservicesmediacarousel";
import hospitalImg from "../Assets/tech/tech-carousel1.png";
import diagnosticsImg from "../Assets/tech/tech-carousel2.png";
import instituteImg from "../Assets/tech/tech-carousel3.png";
import pharmacyImg from "../Assets/tech/tech-carousel4.png";
import healthparksImg from "../Assets/tech/tech-carousel5.png";
import smartImg from "../Assets/tech/tech-carousel6.png";
import techheart from "../Assets/tech/techpeopleback.png";
import techpeople from "../Assets/tech/techpeople.png"
import pulseLine from "../Assets/tech/pulse.png";
import TechClientsCollaborations from "../components/Tech/TechClientsCollaborations";
import doctorImage1 from "../Assets/tech/doctorImage1.png"
import seoMeta from "./seoMeta";
import { Helmet } from "react-helmet-async";
import SchoolCard from "../components/Foundation/SchoolCard";
import { useNavigate } from "react-router-dom";
import TechBanner from "../components/Tech/TechBanner";
import banner from "../Assets/tech/Technologies.png"
import TechnologyBanner from "../components/Foundation/TechnologyBanner";
import TestimonialSlider from "../components/Health/TestimonialSlider";


const Technologies = () => {
    const navigate=useNavigate();
  const meta = seoMeta["/Technologies"];
const logos = [
  { src: require('../Assets/tech/Our-Partners/partners-1.png'), alt: 'Partner 1' },
  { src: require('../Assets/tech/Our-Partners/partners-2.png'), alt: 'Partner 2' },
  { src: require('../Assets/tech/Our-Partners/partners-3.png'), alt: 'Partner 3' },
  { src: require('../Assets/tech/Our-Partners/partners-4.png'), alt: 'Partner 4' },
  { src: require('../Assets/tech/Our-Partners/partners-5.png'), alt: 'Partner 5' },
  { src: require('../Assets/tech/Our-Partners/partners-6.png'), alt: 'Partner 6' },
  { src: require('../Assets/tech/Our-Partners/partners-7.png'), alt: 'Partner 7' },
  { src: require('../Assets/tech/Our-Partners/partners-8.png'), alt: 'Partner 8' },
  { src: require('../Assets/tech/Our-Partners/partners-9.png'), alt: 'Partner 9' },
  { src: require('../Assets/tech/Our-Partners/partners-10.png'), alt: 'Partner 10' },
  { src: require('../Assets/tech/Our-Partners/partners-11.png'), alt: 'Partner 11' },
  { src: require('../Assets/tech/Our-Partners/partners-12.png'), alt: 'Partner 12' },
  { src: require('../Assets/tech/Our-Partners/partners-13.png'), alt: 'Partner 13' },
  { src: require('../Assets/tech/Our-Partners/partners-14.png'), alt: 'Partner 14' },
  { src: require('../Assets/tech/Our-Partners/partners-15.png'), alt: 'Partner 15' },
  { src: require('../Assets/tech/Our-Partners/partners-16.png'), alt: 'Partner 16' },
  { src: require('../Assets/tech/Our-Partners/partners-17.png'), alt: 'Partner 17' },
  { src: require('../Assets/tech/Our-Partners/partners-18.png'), alt: 'Partner 18' },
  { src: require('../Assets/tech/Our-Partners/partners-19.png'), alt: 'Partner 19' },
  { src: require('../Assets/tech/Our-Partners/partners-20.png'), alt: 'Partner 20' },
  { src: require('../Assets/tech/Our-Partners/partners-21.png'), alt: 'Partner 21' },
  { src: require('../Assets/tech/Our-Partners/partners-22.png'), alt: 'Partner 22' },
  { src: require('../Assets/tech/Our-Partners/partners-23.png'), alt: 'Partner 23' },
  { src: require('../Assets/tech/Our-Partners/partners-24.png'), alt: 'Partner 24' },
  { src: require('../Assets/tech/Our-Partners/partners-25.png'), alt: 'Partner 25' },
  { src: require('../Assets/tech/Our-Partners/partners-26.png'), alt: 'Partner 26' },
  { src: require('../Assets/tech/Our-Partners/partners-27.png'), alt: 'Partner 27' },
  { src: require('../Assets/tech/Our-Partners/partners-28.png'), alt: 'Partner 28' },
  { src: require('../Assets/tech/Our-Partners/partners-29.png'), alt: 'Partner 29' },
  { src: require('../Assets/tech/Our-Partners/partners-30.png'), alt: 'Partner 30' },
  { src: require('../Assets/tech/Our-Partners/partners-31.png'), alt: 'Partner 31' },
          ];
const paragraphs = [
    `VCNR Technologies is the digital powerhouse of the VCNR Group, specialized in building sector specific SaaS products and delivering scalable digital services that solve realtime operational problems across domains. Our strength lies in combining domain depth with technology innovation, delivering measurable business outcomes to internal and external clients alike.`,
    `Our model blends SaaS products with digital services, creating steady value and stronger client relationships. By pairing domain expertise with technology innovation, we drive sustainable growth and measurable outcomes.`,
  ];
const paragraphs1 = [
  `We measure our success with the success stories of our patients. Through words, videos, and shared memories, We honor the strength of those who have healed with us. Their stories inspire our teams to go further.`
];
  const technolgyCards = [
{ title: "Industrial Automation & Process Control", image: Img1 },
  { title: "IoT & Smart Device Integration", image: Img2 },
  { title: "Our Technical Team at Work", image: Img3 },
  { title: "Innovating in IT Solutions", image: Img4 },
  { title: "Delivering End-to-End Technical Supports", image: Img5 },
  { title: "Driving Technology Excellence Together", image: Img6 },
];
const quickAccessCards = [
  {
    title: "Step Into Opportunity\nGet the Brochure",
    buttonText: "Download Recruitment Brochure",
    buttonLink: "#"
  },
  {
    title: "Turn Connections\ninto Commissions",
    buttonText: "Referral Program Info",
    buttonLink: "#",
  },
  {
    title: "Connecting Talent\nwith Opportunity",
    buttonText: "Contact VCNR HR Team",
    buttonLink: "#"
  },
  {
    title: "Stay Ahead. Get Hired.\nOn WhatsApp",
    buttonText: "Join Our WhatsApp Hiring Channel",
    buttonLink: "#"
  }
];

const aboutTestimonials = [
  {
    stars: 5,
    title: "Amazing Experience!",
    text: "The whole journey was seamless and smooth. Would recommend to everyone!",
    author: "Ravi Kumar",
    location: "India, Bangalore",
    img: "https://i.pravatar.cc/40?img=9",
  },
  {
    stars: 4,
    title: "Truly Professional",
    text: "The team was very helpful and knowledgeable. They guided us at every step and made sure we got the best outcome.",
    author: "Neha Patel",
    location: "India, Mumbai",
    img: "https://i.pravatar.cc/40?img=10",
  },
  {
    stars: 5,
    title: "Exceeded Expectations",
    text: "From the first call to the final delivery, everything was well-managed and executed beyond my expectations.",
    author: "Mohammed Irfan",
    location: "India, Hyderabad",
    img: "https://i.pravatar.cc/40?img=11",
  },
  {
    stars: 4,
    title: "Reliable Support",
    text: "Even after the service was completed, they stayed in touch and provided great support when needed.",
    author: "Divya Menon",
    location: "India, Kochi",
    img: "https://i.pravatar.cc/40?img=12",
  },
  {
    stars: 5,
    title: "Effortless Process",
    text: "The process was transparent and smooth. I didn’t feel stressed at all and was kept informed throughout.",
    author: "Ankit Sharma",
    location: "India, Delhi",
    img: "https://i.pravatar.cc/40?img=13",
  },
  {
    stars: 5,
    title: "Highly Recommended",
    text: "One of the best service providers I’ve come across. Their ethics, efficiency, and execution are remarkable.",
    author: "Kritika Jain",
    location: "India, Pune",
    img: "https://i.pravatar.cc/40?img=14",
  },
  {
    stars: 5,
    title: "Customer First Approach",
    text: "They truly put the customer first. Every need of ours was taken care of. Thank you for such a positive experience.",
    author: "Ramesh Babu",
    location: "India, Chennai",
    img: "https://i.pravatar.cc/40?img=15",
  },
  {
    stars: 4,
    title: "Smooth Collaboration",
    text: "We worked on a collaborative project and it went smoothly thanks to their clear communication and technical expertise.",
    author: "Sonal Kapoor",
    location: "India, Jaipur",
    img: "https://i.pravatar.cc/40?img=16",
  },
];

const servicesData = [
  {
    title: "Digital Platforms",
    description: "Mobile front, Design first, API driven and Scalable digital platforms enriched with analytical dashboards to empower various generic business activities across domains.",
    image: hospitalImg,
    link:"https://vcnrtech.com/"
  },
  {
    title: "Legacy Application Modernization",
    description: "Seemless migration of the legacy applicatons to the latest trending technologies to make them more effective and user friendly without breaking the core functionalities.",
    image: diagnosticsImg,
        link:"https://vcnrtech.com/"

  },
  {
    title: "Strategy consultation",
    description: "Enerprise grade, complaiance aware technical and business strategy consultation via ODC, staff augmentation and implementation services varying from standard application development to IOT, AI and Cloud architectured solutions.",
    image: instituteImg,
        link:"https://vcnrtech.com/"

  },
  {
    title: "Custom solutions",
    description: "Domain specific tailor made digital solutions for real time problems catering across the globe irrespective of language and culture",
    image: pharmacyImg,
        link:"https://vcnrtech.com/"

  },
  {
    title: "Automation solutions",
    description: "Process automation for both digital and indistrial workflows to improve the productivity and to help the knowledge transition",
    image: healthparksImg,
        link:"https://vcnrtech.com/"

  },
  {
    title: "Smart Health care systems",
    description: "HiPAA kind of compliance aware digital platforms for Healthcare sector, integrated with IOT sensors and AI based engines for realtime data analysis",
    image: smartImg,
        link:"https://vcnrtech.com/"

  },
];


  return (
    <>
    <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>

<TechnologyBanner />
      {/* <TechBanner
  backgroundImage={banner}
  bannerHeading={<>Where People, Purpose, <b>and Technology Connect</b></>}
  subText="At VCNR Technologies, we build technology that puts people first. From AI to automation, our solutions don't just solve problems, they make everyday lives better, smarter, and more connected. We are not just shaping the future of tech, we are making it meaningful."
  buttonText="Know More"
  onButtonClick="https://vcnrtech.com/"
/> */}
   {/* <HeartBanner
      heading="Leading the Digital Leap <br />in Mobile & Web Development"
      subtext="At VCNR Technologies, we build technology that puts people first.From AI to automation, our solutions don’t just solve problems, they make everyday lives better, smarter, and more connected. We are not just shaping the future of tech, we are making it meaningful."
      buttonText="Know More"
      onButtonClick={() => window.location.href = "https://vcnrtech.com/"}
      heartImageSrc={techheart}
      peopleImageSrc={techpeople}
      pulseLineSrc={pulseLine}
/> */}

<ParallaxSection><SubStory
      title={<>Our Technologies Story</>}
      subtitle="Transforming Industries With Deep Tech And Sector Expertise"
      paragraphs={paragraphs}
    /></ParallaxSection>
    <ParallaxSection><SubStone
  imageSrc={bgImage}
  heading={<>We don’t just deliver Solutions, <br /> we deploy transformation.</>}
  buttonText="About Us"
  onButtonClick={() => window.location.href = "https://vcnrtech.com/"}
/></ParallaxSection>
<ParallaxSection><SubJoinSection
  image={doctorImage}
  title={<>What We Do</>}
  subtitle={<>SaaS Products</>}
  description={<>We design and deliver IP-led SaaS platforms focused on industry-specific needs, especially for mid-sized businesses and MSMEs.<br /><b>Construction</b> – ERP-lite, Purchasing, Vendor Billing, Labour Management, Project Management & Cost Control, Asset Management <br />
  <b>Healthcare</b> –  Digital Health systems, Realtime patient tracking systems, telemedicine, and diagnostics which is powered by AI in process automation, making healthcare more accessible and responsive.</>}
  secondaryText=""
  // buttonText = ""
  secondButtonText = ""
  // buttonLink=""           // ← primary button link
  secondButtonLink=""
/></ParallaxSection>

    <ParallaxSection>
<SchoolCard
  schoolName={<>Operating Model & Client Strategy</>}
  tagline="Dual Engine Model: SaaS products + Services"
  description={<>
<b>Sector-Focused Playbook:</b> Built for Construction, MSME Manufacturing, and Healthcare<br />
<b>Product-Led Growth:</b> All platforms are internally validated through VCNR’s own use cases<br />
<b>Hybrid Engagements:</b> A mix of product, service, and ODC creates stronger client relationships.<br />
<b>MVP → Pilot → Scale:</b> Proven approach that ensures iterative success
</>}
  buttonText=""
  buttonLink="/Career"
  schoolBgImage={doctorImage1}
/>

</ParallaxSection>
<ParallaxSection><Subservicesmediacarousel
      title="Core Offerings"
      subtitle="The VCNR Tech Stack: Designed to Drive Change<br />
Through Purposeful Mobile and Web Development"
      services={servicesData}
    /></ParallaxSection>
    <ParallaxSection><OutreachSection
          title="Our Technologies Portfolio"
          // subheading="Extending Care Beyond Walls Through Hospitals, Health Parks, and a Seamless Hospital Integrated System."
          // description={[
          //   "At VCNR, we believe care doesn’t stop at the hospital doors only. Through our expanding network of hospitals, new medical centers, health parks, and accessible health plans, our hospital integrated system ensures quality care reaches every corner of the community.",
          //   "Our community health programs go even further, bringing care to the doorstep of those who need it most. We conduct frequent rural health camps, school-based preventive screenings, elderly wellness drives, and even provide life-saving surgeries for underprivileged patients. No matter where someone lives, VCNR is committed to being their partner in health."
          // ]}
          cardsData={technolgyCards}
          // buttonText="Download Voucher"
          // onButtonClick={() => window.alert("Volunteer form will open")}
        /></ParallaxSection>
                
<TechClientsCollaborations />
        <ParallaxSection><SubStory
      title={
    <>
      From statewide digital transformation to SME-driven innovation, We at VCNR Technologies doesn’t 
      just deliver solutions—we forge the future by empowering every community that we serve. Our 
      commitment is not limited to mere implementation, but to drive a meaningful, lasting change 
      that shapes tomorrow.
    </>
  }
    />
      <div style={{ textAlign: 'center', marginBottom: '2.5rem', padding: '10px' }}>
    <h2 style={{ fontSize: '3rem', fontWeight: 300, margin: 0, textUnderlineOffset: '8px', color: '#fff', lineHeight: 1 }}>
      Reviews & Testimonials
    </h2>
    <h3 style={{ fontSize: '1.5rem', fontWeight: 300, margin: '1.2rem 0 0.5rem 0', color: '#fff', lineHeight: 1 }}>
      Stories of Transformation
    </h3>
    <p style={{ color: '#fff', fontSize: '1.15rem', maxWidth: 900, margin: '0 auto', marginBottom: '1.5rem', lineHeight: 1.4 }}>
      Meet the people behind the numbers. From a young girl now pursuing medical school to a farmer doubling his yield through our training, these are stories of courage, community, and collective growth
    </p>
  </div>

<TestimonialSlider
    testimonials={aboutTestimonials}
    backgroundImage={testimonialbg}
  />  


    </ParallaxSection>

        <ParallaxSection><LeaderBuildWithUs /></ParallaxSection>
          <ParallaxSection><LogoCarousel logos={[...logos, ...logos]} /></ParallaxSection>
          
          

    </>
  );
};

export default Technologies;
